import PasswordRecoveryPageContainer from "./PasswordRecoveryPageContainer";

export default PasswordRecoveryPageContainer;
